function moneyFormat(amount) {
  return new Intl.NumberFormat("mn-MN", {
    style: "currency",
    currency: "MNT",
    currencyDisplay: "code",
  })
    .format(amount)
    .replace("MNT", "");
}

module.exports = moneyFormat;
